.boardShell {
    width: 100%;
    background-color: var(--mantine-color-white);
}

/* ---- Lane headings (shared) ---- */

.laneHeading {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-height: var(--dispatch-lane-header-height, 1.875rem);
    padding: 0.4rem 1rem;
    box-sizing: border-box;
}

.laneHeading::before {
    content: '';
    width: 2px;
    height: 0.7rem;
    border-radius: 1px;
    flex-shrink: 0;
}

.laneHeading_needs_action {
    background-color: var(--mt-signal-attention-0);
}

.laneHeading_notify_drivers {
    background-color: var(--mt-signal-pending-0);
}

.laneHeading_dispatched {
    background-color: var(--mt-signal-positive-0);
}

.laneHeading_needs_action::before {
    background-color: var(--mt-signal-attention-5);
}

.laneHeading_notify_drivers::before {
    background-color: var(--mt-signal-pending-5);
}

.laneHeading_dispatched::before {
    background-color: var(--mt-signal-positive-5);
}

.laneHeadingLabel {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 700;
    padding: 0 0.5rem;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--mantine-color-gray-8);
}

.laneCount {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.15rem;
    height: 1.15rem;
    padding: 0 0.5rem;
    border-radius: var(--mantine-radius-xl);
    background-color: var(--mantine-color-gray-1);
    font-family: var(--mantine-font-family-monospace);
    font-size: 0.8rem;
    line-height: 1;
    font-weight: 700;
    color: var(--mantine-color-gray-7);
    font-variant-numeric: tabular-nums;
}

.laneHeading_needs_action .laneCount {
    background-color: var(--mt-signal-attention-1);
    color: var(--mt-signal-attention-8);
}

.laneHeading_notify_drivers .laneCount {
    background-color: var(--mt-signal-pending-0);
    color: var(--mantine-color-gray-7);
}

.laneHeading_dispatched .laneCount {
    background-color: var(--mt-signal-positive-0);
    color: var(--mt-signal-positive-8);
}

/* ---- Card layout: stacked lanes, responsive card grid ---- */

.laneGrid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(17.5rem, 1fr));
    gap: 0.7rem;
    padding: 0.35rem 1rem 0.65rem;
}
